import { Compass, ShoppingBag, Cog, Rocket, Headphones } from "lucide-react";
import { SectionTag, MaskedLine } from "./Motion";
import Pipeline from "./Pipeline";

const steps = [
  {
    icon: Compass,
    title: "Discover",
    desc: "Browse the catalogue or brief our desk — we map the fastest route to your goal.",
    testid: "order-step-discover",
  },
  {
    icon: ShoppingBag,
    title: "Order",
    desc: "Transparent pricing, instant confirmation, zero paperwork.",
    testid: "order-step-order",
  },
  {
    icon: Cog,
    title: "Process",
    desc: "Our engine allocates, schedules and quality-checks every unit of work.",
    testid: "order-step-process",
  },
  {
    icon: Rocket,
    title: "Fulfil",
    desc: "Delivery tracked live, from the first action to the final milestone.",
    testid: "order-step-fulfil",
  },
  {
    icon: Headphones,
    title: "Support",
    desc: "Humans on standby 24/7 — long after the order closes.",
    testid: "order-step-support",
  },
];

export default function OrderFlow() {
  return (
    <section id="process" data-testid="order-flow-section" className="relative py-28 sm:py-36">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-16">
        <SectionTag index="09" label="How It Works" testid="order-flow-tag" />
        <h2 className="mt-6 max-w-3xl text-4xl font-bold tracking-tight text-neutral-50 sm:text-5xl">
          <MaskedLine>Five steps.</MaskedLine>
          <MaskedLine delay={0.12} innerClassName="font-serif italic font-medium text-gold-grad">
            Zero friction.
          </MaskedLine>
        </h2>

        <div className="mt-20">
          <Pipeline steps={steps} lineTestid="order-flow-progress-line" />
        </div>
      </div>
    </section>
  );
}
